import { mappingsColumnConfig } from '@/components/Pricing/Mappings/MappingTables';
import { Box, Button, Column, Icon, Table } from '@palmetto/palmetto-components';
import { useParams, useSearchParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { useGetOrgPriceSheetMappingsQuery } from '../../../../../services/organizations';
import { TableLoading } from '../../../../TableLoading';

export const Mappings = () => {
  const { alias = '', programType = '' } = useParams<{ alias: string; programType: ProgramType }>();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || undefined;

  const {
    data,
    isLoading: isOrgPricingLoading,
    isFetching,
  } = useGetOrgPriceSheetMappingsQuery(
    { alias, programType: programType as ProgramType, id },
    { skip: !alias || !programType },
  );
  const isLoading = isOrgPricingLoading;

  return (
    <Box margin="0 lg 0 lg">
      {isFetching || isLoading ? (
        <TableLoading rows={12} />
      ) : (
        <Table
          rowKey="id"
          columns={
            [
              ...mappingsColumnConfig.baseStart,
              ...mappingsColumnConfig[(programType as ProgramType) ?? ProgramType.solar],
              ...mappingsColumnConfig.baseEnd,
              {
                sticky: 'right',
                render: (_cell: any, row: any) => (
                  <Box direction="row" gap="lg" alignItems="center">
                    {row.status !== 'archived' && (
                      <Button
                        size="sm"
                        variant="tertiary"
                        tone="neutral"
                        onClick={() => {
                          window.open(
                            `/admin/pricing/${row.programType}/mappings/edit/${row.id}`,
                            '_blank',
                            'noopener,noreferrer',
                          );
                        }}
                      >
                        <Icon color="body-primary" name="settings" size="sm" />
                      </Button>
                    )}
                  </Box>
                ),
              },
            ] as Column[]
          }
          rows={data ?? []}
          isLoading={isLoading || isFetching}
          isScrollable={{ x: true }}
          hasStickyHeader
        />
      )}
    </Box>
  );
};
